export const API_URL_AUTH = 'https://apiauth.psisimonline.id';
export const API_URL_PAY = 'https://apipayment1.psisimonline.id';

export const API_REFRESH =
  'https://srvauth.psisim.net/mopsimapp/refreshtokendevice';
export const API_OUTLET =
  'https://srvauth.psisim.net/mopsimapp/all-outlet-group';
export const API_DATA = 'https://srvpay1.psisim.net/mopsimapp/alltotal-sim';
